<template>
  <b-modal
    class="modal-forget-password"
    ref="modalForgetPassword"
    title="Mot de passe oublié ?"
    @ok="forgetPasswordOk"
    @show="initModal"
  >
    <b-form ref="forgetPasswordForm" @submit="forgetPasswordOnSubmit">
      <form-auth
        ref="formAuth"
        :showInput="{ password: false }"
        v-model="value"
      ></form-auth>
    </b-form>
    <template #modal-footer="{ ok }">
      <b-button @click="hide" class="button-color">Annuler</b-button>
      <b-button :disabled="!checkFormValidity" variant="success" class="button-color" @click="ok">
        Valider
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import FormAuth from './FormAuth.vue'

export default {
  name: 'modal-forget-password',
  data () {
    return {
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    forgetPasswordOnSubmit: function () {
      const vm = this
      vm.forgetPasswordLoad = true
      window.$.ajax({
        method: 'POST',
        url: `${process.env.API_AUTH}/labco/user-forget-password`,
        data: {
          login: vm.value.login,
          correspondant: vm.value.correspondant
        }
      })
        .done(function () {
          vm.hide()
          vm.$bvToast.toast('Vous allez recevoir un mail avec la procédure créé un nouveau mot de passe', {
            title: 'Oubli de mot de passe',
            variant: 'success',
            solid: true
          })
        })
        .fail(function (xhr) {
          const errorMessage = window.fail(xhr)
          vm.$bvToast.toast(errorMessage, {
            title: 'Oups !',
            variant: 'warning',
            solid: true
          })
        })
        .always(function () {
          vm.forgetPasswordLoad = false
        })
    },
    forgetPasswordOk: function (bvModalEvt) {
      const vm = this

      bvModalEvt.preventDefault()

      if (!this.$refs.forgetPasswordForm.checkValidity()) {
        return
      }

      vm.forgetPasswordOnSubmit()
    },
    show () {
      this.$refs.modalForgetPassword.show()
    },
    hide () {
      this.$refs.modalForgetPassword.hide()
    },
    initModal () {
      setTimeout(() => {
        this.$refs.formAuth.$refs.login.focus()
      }, 0)
    }
  },
  computed: {
    checkFormValidity () {
      const vm = this
      let valid = false

      if (
        vm.value.login &&
        vm.value.login.length > 0 &&
        vm.value.correspondant &&
        vm.value.correspondant.length > 0
      ) {
        valid = true
      }

      return valid
    }
  },
  components: {
    FormAuth
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Auth/ModalForgetPassword.vue